import React from 'react';
import { GenericReportingDropdowns } from '../../containers/GenericReportingDropdowns';
import DropdownContainer from '../../containers/DropdownContainer';

const InfluencerSummaryPageDropdowns = () => {
  return (
        <GenericReportingDropdowns
          includeDateRange={true}
          includeGranularity={true}
          includeRegion={false}
          includeTooltips={false}
          includeTitles={true}
          includeCompareDateRange={true}
          extraDropdowns={
            [
            <DropdownContainer dropdown_name="influencer_unique_labels" />
            ]
          }
        />
  );
};

export default InfluencerSummaryPageDropdowns;